import { render, staticRenderFns } from "./SlideUpAlert.vue?vue&type=template&id=cd7cb434&scoped=true&"
import script from "./SlideUpAlert.vue?vue&type=script&lang=js&"
export * from "./SlideUpAlert.vue?vue&type=script&lang=js&"
import style0 from "./SlideUpAlert.vue?vue&type=style&index=0&id=cd7cb434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7cb434",
  null
  
)

export default component.exports